import { render, staticRenderFns } from "./CollapseCardBody.vue?vue&type=template&id=62e41d16&"
import script from "./CollapseCardBody.vue?vue&type=script&lang=js&"
export * from "./CollapseCardBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports